module.exports = __webpack_public_path__ + "static/media/calendar.1f2df1d8.svg";